import React from "react";
import { getHours } from "../../util";
import moment from "moment";

function WorkingDetail({ attendances }) {
  const currentMonth = moment().month();
  const currentYear = moment().year();

  const filteredAttendances = attendances?.filter(
    (att) =>
      moment(att.date).month() === currentMonth &&
      moment(att.date).year() === currentYear &&
      att.workedHours
  );

  const totalDays = moment().date();

  const workedDays = filteredAttendances?.length;

  const workedHours = filteredAttendances
    ?.map((a) => {
      const workDuration = moment.duration(a?.workedHours);
      return workDuration;
    })
    .reduce((a, b) => a + b, 0);

  return (
    <>
      <div className="card-footer p-3 p-md-4">
        <div className="row gx-xxl-5">
          <div className="col-sm-4 mb-3">
            <div className="text-center shadow-sm px-3 py-4 rounded bg-light block-hover">
              <h4>{totalDays}</h4>
              <p className="text-muted m-0">Calendar Days</p>
            </div>
          </div>
          <div className="col-sm-4 mb-3">
            <div className="text-center shadow-sm px-3 py-4 rounded bg-light block-hover">
              <h4>{workedDays}</h4>
              <p className="text-muted m-0">Days Worked</p>
            </div>
          </div>
          <div className="col-sm-4 mb-3">
            <div className="text-center shadow-sm px-3 py-4 rounded bg-light block-hover">
              <h4>{getHours(workedHours)}</h4>
              <p className="text-muted m-0">Worked Hours</p>
            </div>
          </div>
        </div>
      </div>
      {/*.card-footer*/}
    </>
  );
}

export default WorkingDetail;
